import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { getHours, getMinutes, isSameDay, set } from 'date-fns';
import { FormField, FormMessage } from '@components/ui/form';
import { DatePicker } from '@components/ui/form/date';
import { FormItemWrapper } from '@components/ui/form/itemWrapper';
import { TimePicker } from '@components/scheduling/timePicker';
import { SchedulerCompanyTime } from '@components/scheduler/companyTime';
import { ExternalScheduleWhenInputsProps } from './types';

export const ExternalScheduleWhenInputs = ({
  idPrefix,
  disabled,
  takenDays = [],
  currentDay,
}: ExternalScheduleWhenInputsProps) => {
  const { t } = useTranslation('app', { keyPrefix: 'forms' });
  const { control } = useFormContext<{ date: Date; time?: Date }>();
  const disabledDays = takenDays.filter((day) => !currentDay || !isSameDay(day, currentDay));

  return (
    <div className="flex flex-col gap-2.5">
      <FormField
        control={control}
        name="date"
        render={({ field: { value, onChange, ...field } }) => (
          <FormItemWrapper label={t('date.label')} required>
            <DatePicker
              {...field}
              value={value || null}
              onChange={onChange}
              mode="single"
              className="h-11 w-full"
              disabled={disabled}
              disabledDays={disabledDays}
              placeholder={t('default.select.placeholder')}
            />
          </FormItemWrapper>
        )}
      />
      <FormField
        control={control}
        name="time"
        render={({ field: { value, onChange } }) => (
          <div className="flex flex-col gap-1">
            <TimePicker
              id={`${idPrefix}-time`}
              label={`${t('time.label')}*`}
              value={value ? getHours(value) * 60 + getMinutes(value) : undefined}
              onChange={(minutes) =>
                onChange(
                  set(value || new Date(), {
                    hours: Math.floor(minutes / 60),
                    minutes: minutes % 60,
                    seconds: 0,
                    milliseconds: 0,
                  }),
                )
              }
              disabled={disabled}
            />
            <FormMessage />
          </div>
        )}
      />
      <SchedulerCompanyTime />
    </div>
  );
};
